module.exports = __webpack_public_path__ + "static/media/atomi-validator-logo-teksti.376112de.png";